import api from '@/utils/api';

export function getCartItems() {
  return api.get('api/v1/cart/');
}

export function deleteCartItem(itemId: number) {
  return api.delete(`api/v1/cart/item/${itemId}/`);
}

export function deleteGiftNote() {
  return api.delete(`/api/v1/cart/gift-note/`);
}
